import { verifyFeatureAccess } from '../components/user-feature-guard/utils'
import useGroup from './useGroup'
import useProfileSession from './useProfileSession'
import useProducts from './useProducts'

const useFeatureGuard = () => {
  const { hasContentHubAccess } = useProducts()
  const { profile } = useProfileSession()
  const { isInGroup } = useGroup()

  const hasAccess = (allowedGroups, feature) => {
    return (
      isInGroup(allowedGroups) &&
      verifyFeatureAccess(profile?.features, feature, profile?.userGroup, hasContentHubAccess)
    )
  }

  const hasFeatureAccess = (feature) => {
    return verifyFeatureAccess(profile?.features, feature, profile?.userGroup, hasContentHubAccess)
  }

  return {
    hasAccess,
    hasFeatureAccess
  }
}

export default useFeatureGuard
